import * as React from 'react';
import { t } from 'i18next';

import { AppConfigurationStore } from '../../stores/AppConfigurationStore';
import { BaseComponent } from '../BaseComponent';
import { DialogActions, NewSceneCancelError } from '../../actions/DialogActions';
import { DownloadHelper } from '../../utils/DownloadHelper';
import { ImportButton } from './ImportButton';
import { LongButton } from '../LongButton';
import { ProjectSettingsStore } from '../../stores/ProjectSettingsStore';
import { SaveType } from '../../constants/Enums';
import { SceneActions } from '../../actions/SceneActions';
import { SceneStore } from '../../stores/SceneStore';
import { ViewSettingsActions } from '../../actions/ViewSettingsActions';

interface BrowserProjectButtonsState {
    downloadPossible: boolean;
}

export class BrowserProjectButtons extends BaseComponent<{}, BrowserProjectButtonsState> {
    protected openInputElement: HTMLInputElement;

    constructor(props: {}) {
        super(props);
        this.newProject = this.newProject.bind(this);
        this.onChange = this.onChange.bind(this);
        this.openProject = this.openProject.bind(this);
        this.openProjectFileDialog = this.openProjectFileDialog.bind(this);
        this.setOpenElement = this.setOpenElement.bind(this);
    }

    public componentWillMount(): void {
        this.addStoreListener(SceneStore, this.onChange);
        this.addStoreListener(ProjectSettingsStore, this.onChange);
        this.onChange();
    }

    public render(): JSX.Element {
        if (AppConfigurationStore.getState().fileBasedProjects) {
            return (
                <div className="long-button-group popup-buttons">
                    <LongButton icon="new-button" onClick={this.newProject}>{t('New')}</LongButton>
                    <LongButton icon="open-button" onClick={this.openProjectFileDialog}>
                        <input
                            type="file"
                            accept=".obk, .pbox, .pec"
                            onChange={this.openProject}
                            className="open-input-element"
                            style={{display: 'none'}}
                            ref={this.setOpenElement}
                        />
                        <span>{t('Open')}</span>
                    </LongButton>
                    <ImportButton/>
                    <LongButton
                        icon="save-button"
                        disabled={!this.state.downloadPossible}
                        onClick={DownloadHelper.downloadProjectContainer}
                    >
                        <span>{t('Save as')}</span>
                    </LongButton>
                </div>
            );
        }

        return (
            <div className="long-button-group popup-buttons">
                <LongButton
                    icon="new-button"
                    onClick={this.newProject}
                >
                    {t('New')}
                </LongButton>
            </div>
        );
    }

    protected setOpenElement(node: HTMLInputElement): void {
        this.openInputElement =  node;
    }

    protected onChange(): void {
        this.setState({
            downloadPossible: SceneStore.getState().elementCount > 0 || ProjectSettingsStore.getState().floorPlan != null
        });
    }

    protected openProjectFileDialog(): void {
        if (this.openInputElement) {
            this.openInputElement.click();
        }
    }

    protected async openProject(): Promise<void> {
        return DialogActions.openProjectFromFileInput(this.openInputElement);
    }

    protected async newProject(): Promise<void> {
        let result: SaveType | null = null;

        try {
            result = await DialogActions.newProject(!this.state.downloadPossible);
        } catch (error) {
            if (!(error instanceof NewSceneCancelError)) {
                throw error;
            }
        }

        if (result == null) {
            return;
        }

        if (result === SaveType.DEVICE) {
            await DownloadHelper.downloadProjectContainer();
        }

        ViewSettingsActions.closeMessage();
        ViewSettingsActions.changeHamburger(null);
        await SceneActions.newScene(null, SaveType.NOT);
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/hamburgermenu/BrowserProjectButtons.tsx